import { useNavigate } from 'react-router';
import { LogOut } from 'lucide-react';
import { AuthLayout } from '@/components/AuthLayout';
import { PasswordForm } from '@/components/form/PasswordForm';
import { useAuthStore } from '@/stores/useAuthStore';

/**
 * Définition du mot de passe local, imposée par RequireAuth tant que le compte n'en a pas (connexion SSO) : étape de
 * connexion hors de l'application (ni sidebar ni menu), dont on ne sort qu'en définissant le mot de passe ou en se
 * déconnectant. Process front seulement : l'API ne bloque rien sans mot de passe local
 */
export function DefinePasswordPage() {
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();

  return (
    <AuthLayout
      title="Définissez votre mot de passe de secours"
      subtitle="Une dernière étape avant d'accéder à votre espace"
    >
      <p className="mb-4 text-sm text-slate-600">
        Votre compte n'a pas encore de mot de passe. Ce mot de passe de secours vous permettra de vous connecter avec
        votre email quand la connexion via votre entreprise est indisponible.
      </p>

      <PasswordForm definition onSaved={() => navigate('/', { replace: true })} />

      <div className="mt-6 text-center">
        <button
          type="button"
          onClick={() => void logout()}
          className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-700"
        >
          <LogOut className="w-3 h-3" />
          Se déconnecter
        </button>
      </div>
    </AuthLayout>
  );
}
